import {Component, Input} from '@angular/core';
import {SolarAnalyticsData} from '../../providers/solar-analytics-data';
import {solarAnalyticsSimpleData} from '../../model/meter/solarAnalyticsSimpleData';
import {LoadingController, NavController} from "ionic-angular";
import 'rxjs/add/operator/first';
import {LoggerService} from '../../providers/logger-service';

declare var dataLayer: Array<any>;

@Component({
  selector: 'page-energy-usage',
  templateUrl: 'energy-usage.html'
})
export class EnergyUsage {


  @Input() energyData: solarAnalyticsSimpleData;

  errorMessage: string = 'unable to load data from solar analytics';
  isDataAvailable:boolean = false;

  constructor(public saDataService: SolarAnalyticsData,
              public nav: NavController,
              public loadingCtrl: LoadingController,
              private logger: LoggerService) {
    this.logger.log.debug('Hello EnergyUsage');

  }

   ionViewDidLoad() {

    this.logger.log.debug('ionViewDidLoad');

       let loader = this.loadingCtrl.create({
         content: 'Retrieving your data..',
       });

     this.logger.log.debug('loader.present()');
       loader.present().then(() => {

         this.saDataService.getSolarAnalyticsSimpleData().subscribe(
           res => {
             this.energyData = res;
             this.isDataAvailable = true;
             this.logger.log.debug('assigned result call');
             this.logger.log.debug(this.isDataAvailable);
             this.logger.log.debug(this.energyData);


               this.logger.log.debug('dismisses the loading controller');
               loader.dismiss();
           },
           err => console.warn(this.errorMessage),
           () => {

             this.logger.log.debug('finished call');
           }
         );

       });


     this.logger.log.debug('ionViewDidLoad finished');
     this.logger.log.debug(this.isDataAvailable);
     this.logger.log.debug(this.energyData);

     dataLayer.push({
       'screenPath': 'energy-usage',
       'screenName': 'EnergyUsage'
     });
     dataLayer.push({'event': 'appScreenView'});


   };

// TODO: destroy subscription when you're moving out of this view.

}



// WEBPACK FOOTER //
// ./src/pages/energy-usage/energy-usage.ts